export enum RouteEnums {
	REVIEW_OVERVIEW = 'review-overview',
	IDENTIFIED_ENROLMENTS = 'identified-enrolments',
	HISTORY = 'history',
	QUICK_GUIDE = 'quick-guide'
}
